import { isMobile, isTablet, isDesktop, isAndroid, isIOS, isWindows, isMacOs } from 'react-device-detect';

/**
 * Detects the operating system using react-device-detect library
 * @returns {string} The detected operating system
 */
export function detectOSChatbot() {
  if (isAndroid) {
    return "android";
  } else if (isIOS) {
    return "ios";
  } else if (isWindows) {
    return "windows";
  } else if (isMacOs) {
    return "mac";
  } else {
    return "unknown";
  }
}

/**
 * Detects if the device is mobile (phone or tablet)
 * @returns {boolean} True if device is mobile
 */
export function isMobileDevice() {
  return isMobile || isTablet;
}

/**
 * Detects if the device is a tablet
 * @returns {boolean} True if device is a tablet
 */
export function isTabletDevice() {
  return isTablet;
}

/**
 * Detects if the device is desktop
 * @returns {boolean} True if device is desktop
 */
export function isDesktopDevice() {
  return isDesktop;
}

/**
 * Detects if the device is Android
 * @returns {boolean} True if device is Android
 */
export function isAndroidDevice() {
  return isAndroid;
}

/**
 * Detects if the device is iOS
 * @returns {boolean} True if device is iOS
 */
export function isIOSDevice() {
  return isIOS;
}
